import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule, MatIconModule } from '@angular/material';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { RecoveryCodesComponent } from './recovery-codes.component';
import { RecoveryCodesService } from './services/recovery-codes.service';

@NgModule({
  declarations: [
    RecoveryCodesComponent
  ],
  imports: [
    CommonModule,
    FuseSharedModule,
    TranslateModule,

    MatIconModule,
    MatButtonModule
  ],
  exports: [
    RecoveryCodesComponent
  ],
  providers: [
    RecoveryCodesService
  ]
})
export class RecoveryCodesModule { }
